import authReducer from '../screens/auth/login/reducer';
import languageReducer from '../translation/reducer';
import loadingReducer from '../connected-components/loading/reducer';
import toastReducer from '../connected-components/toast/reducer';
import globalModalReducer from '../connected-components/globalModal/reducer';

export default {
  auth: authReducer,
  lang: languageReducer,
  loading: loadingReducer,
  toast: toastReducer,
  globalModal: globalModalReducer,
};
